import angular from 'angular';
import emailEditor from './emailEditor';
import './style.scss';

export default angular
  .module('emailEditor', [])
  .component('emailEditor', emailEditor).name;
